import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  Paper,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { parse, isBefore } from 'date-fns';

const styles = theme => ({
  dialogTitleTypography: {
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    display: 'inline',
    fontSize: 23
  },
  dialogTitle: {
    display: 'inline-flex',
  },
  selectAtivo: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(4),
    width:  theme.spacing(10),
  },
  textFieldData: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0),
    width: 232,
    marginRight: theme.spacing(2),
  },  
});

class FormDialogFecharVigencias extends React.Component {
  state = {
    dtaInicio: this.props.dtaInicio,
    dtaFim: null,
    errorMessageDataFim: ''
  }

  handleClose = () => {
    this.props.handleClose();
  }

  handleClickSave = async () => {
    let prestador = {
      dtaFim: this.state.dtaFim === null ? null : parse(this.state.dtaFim),
    };
    this.props.handleSave(prestador);
  }  
  
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleBlurDataFim = () => {    
    if (this.state.dtaFim === 'Invalid Date') {      
      this.setState({errorMessageDataFim: 'Data Inválida'});
    } else {
      if (isBefore(parse(this.state.dtaFim), parse(this.state.dtaInicio))){        
        this.setState({errorMessageDataFim: 'Data fim menor que data início'});
      } else {
        this.setState({errorMessageDataFim: ''});
      }
    }
  }

  render () {
    const { open, titulo, classes } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='sm'
          scroll='body'
          fullWidth
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleTypography}>{titulo}</Typography> 
          </DialogTitle>
          <DialogContent>
              <Paper className={classes.paperTable}>
              <FormControl>
                <TextField
                  id='date'
                  error={this.state.errorMessageDataFim !== ''}
                  label={this.state.errorMessageDataFim !== '' ? this.state.errorMessageDataFim : 'Data Fim'}
                  type='date'
                  value={this.state.dtaFim}
                  onChange={this.handleChange}
                  onBlur={this.handleBlurDataFim}
                  inputProps={{
                    name: 'dtaFim',
                  }}
                  className={classes.textFieldData}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              </Paper>        
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              onClick={this.handleClickSave}
              disabled={this.state.errorMessageDataFim !== ''}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogFecharVigencias);
